import React from 'react';
import {
    StyledPlaceholder,
} from './styled';

const Placeholder = () => {
    return (
        <StyledPlaceholder />
    )
}

export default Placeholder
